import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("CARGAR_LOCAL", newActions, newReducers);

const cargarLocalThunk = (data) => {
  const url = `${baseUrl}/local`;
  return createThunk(axios, "post", duck.actions, url, data);
};

const duckEditLocal = createDuck("EDITAR_LOCAL", newActions, newReducers);

const editLocalThunk = (data) => {
  const url = `${baseUrl}/local`;
  return createThunk(axios, "patch", duckEditLocal.actions, url, data);
};

const duckCategoriasForSelect = createDuck(
  "GET_CATEGORIAS_FOR_SELECT",
  newActions,
  newReducers
);

const categoriasForSelectThunk = (data) => {
  const url = `${baseUrl}/getCategoriasForSelect`;
  return createThunk(axios, "get", duckCategoriasForSelect.actions, url, data);
};

const duckGetLocales = createDuck("GET_LOCALES", newActions, newReducers);

const getLocalesThunk = (
  page,
  limit,
  localId = null,
  nombre = null,
  categoria = null
) => {
  let url = localId
    ? `${baseUrl}/getLocales?page=${page}&limit=${limit}&localId=${localId}`
    : `${baseUrl}/getLocales?page=${page}&limit=${limit}`;

  if (nombre) {
    url = url + `&nombre=${nombre}`;
  }
  if (categoria) {
    url = url + `&categoria=${categoria}`;
  }
  return createThunk(axios, "get", duckGetLocales.actions, url, null);
};

const duckProfesionalesByLocal = createDuck(
  "PROFESIONALES_BY_LOCAL",
  newActions,
  newReducers
);

const profesionalesByLocalThunk = (id, page, limit) => {
  const url = `${baseUrl}/getProfesionalesByLocal/${id}?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duckProfesionalesByLocal.actions, url, null);
};

const duckLocalById = createDuck("LOCAL_BY_ID", newActions, newReducers);

const localByIdThunk = (id) => {
  const url = `${baseUrl}/v2/getLocalById`;
  return createThunk(axios, "post", duckLocalById.actions, url, { id });
};

const duckServiciosPadre = createDuck(
  "GET_SERVICIOS_PADRE",
  newActions,
  newReducers
);

const serviciosPadreThunk = (id, page, limit) => {
  const url = `${baseUrl}/getServiciosPadre/${id}?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duckServiciosPadre.actions, url, null);
};

const duckServiciosHijos = createDuck(
  "GET_SERVICIOS_HIJOS",
  newActions,
  newReducers
);

const serviciosHijosThunk = (id, page, limit) => {
  const url = `${baseUrl}/getServiciosHijos/${id}?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duckServiciosHijos.actions, url, null);
};

const duckHorariosByLocal = createDuck(
  "HORARIOS_BY_LOCAL",
  newActions,
  newReducers
);

const horariosByLocalThunk = (
  id,
  page,
  limit,
  profesional = null,
  servicio = null,
  dia = null,
  hora = null
) => {
  let url = `${baseUrl}/getHorariosByLocal/${id}?page=${page}&limit=${limit}`;
  if (profesional) {
    url = `${url}&profesional=${profesional}`;
  }
  if (servicio) {
    url = `${url}&servicio=${servicio}`;
  }
  if (dia) {
    url = `${url}&dia=${dia}`;
  }
  if (hora) {
    url = `${url}&hora=${hora}`;
  }
  return createThunk(axios, "get", duckHorariosByLocal.actions, url, null);
};

const duckEliminarHorario = createDuck(
  "ELIMINAR_HORARIO",
  newActions,
  newReducers
);

const eliminarHorarioThunk = (data) => {
  const url = `${baseUrl}/eliminarHorarioProfesional`;
  return createThunk(axios, "post", duckEliminarHorario.actions, url, data);
};

const duckEliminarImgLocal = createDuck("ELIMINAR_IMG_LOCAL");

const eliminarImgLocalThunk = (data) => {
  const url = `${baseUrl}/eliminarImgLocal`;
  return createThunk(axios, "post", duckEliminarImgLocal.actions, url, data);
};

const duckEliminarImgBannerLocal = createDuck("ELIMINAR_IMG_BANNER_LOCAL");

const eliminarImgBannerLocalThunk = (data) => {
  const url = `${baseUrl}/eliminarImgBannerLocal`;
  return createThunk(
    axios,
    "post",
    duckEliminarImgBannerLocal.actions,
    url,
    data
  );
};

const duckSugerencias = createDuck("GET_SUGERENCIAS", newActions, newReducers);

const getSugerenciasThunk = (page, limit) => {
  const url = `${baseUrl}/getSugerencias?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duckSugerencias.actions, url, null);
};

const duckAmbientesByLocal = createDuck(
  "AMBIENTES_BY_LOCAL",
  newActions,
  newReducers
);

const getAmbientesByLocalThunk = (id, page, limit) => {
  const url = `${baseUrl}/getAmbientesWithPagination/${id}?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duckAmbientesByLocal.actions, url, null);
};

const duckAddAmbiente = createDuck("CARGAR_AMBIENTE", newActions, newReducers);

const cargarAmbienteThunk = (data) => {
  const url = `${baseUrl}/addAmbiente`;
  return createThunk(axios, "post", duckAddAmbiente.actions, url, data);
};

const duckUpdateAmbiente = createDuck(
  "UPDATE_AMBIENTE",
  newActions,
  newReducers
);

const updateAmbienteThunk = (data) => {
  const url = `${baseUrl}/ambiente`;
  return createThunk(axios, "patch", duckUpdateAmbiente.actions, url, data);
};

const duckAmbienteById = createDuck("AMBIENTE_BY_ID", newActions, newReducers);

const getAmbienteByIdThunk = (id) => {
  const url = `${baseUrl}/ambiente/${id}`;
  return createThunk(axios, "get", duckAmbienteById.actions, url, null);
};

const duckSegurosByLocal = createDuck(
  "SEGUROS_BY_LOCAL",
  newActions,
  newReducers
);

const getSegurosByLocalThunk = (id, page, limit) => {
  const url = `${baseUrl}/getSegurosWithPagination/${id}?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duckSegurosByLocal.actions, url, null);
};

const duckAddSeguro = createDuck("CARGAR_SEGURO", newActions, newReducers);

const cargarSeguroThunk = (data) => {
  const url = `${baseUrl}/addSeguro`;
  return createThunk(axios, "post", duckAddSeguro.actions, url, data);
};

const duckUpdateSeguro = createDuck("UPDATE_SEGURO", newActions, newReducers);

const updateSeguroThunk = (data) => {
  const url = `${baseUrl}/seguro`;
  return createThunk(axios, "patch", duckUpdateSeguro.actions, url, data);
};

const duckSeguroById = createDuck("SEGURO_BY_ID", newActions, newReducers);

const getSeguroByIdThunk = (id) => {
  const url = `${baseUrl}/seguro/${id}`;
  return createThunk(axios, "get", duckSeguroById.actions, url, null);
};

const duckSimularPendientes = createDuck(
  "PROCESAR_PENDIENTES",
  newActions,
  newReducers
);

const procesarHorariosPendientesThunk = (data) => {
  const url = `${baseUrl}/procesarHorariosPendientesPorLocal`;
  return createThunk(axios, "post", duckSimularPendientes.actions, url, data);
};

const duckGetPromos = createDuck("GET_PROMOS", newActions, newReducers);

const getPromosThunk = (data) => {
  const url = `${baseUrl}/getPromos`;
  return createThunk(axios, "post", duckGetPromos.actions, url, data);
};

const duckAddPromo = createDuck("GET_PROMOS", newActions, newReducers);

const addPromoThunk = (data) => {
  const url = `${baseUrl}/addPromo`;
  return createThunk(axios, "post", duckAddPromo.actions, url, data);
};

const duckDeletePromo = createDuck("DELETE_PROMOS", newActions, newReducers);

const deletePromoThunk = (data) => {
  const url = `${baseUrl}/deletePromo`;
  return createThunk(axios, "post", duckDeletePromo.actions, url, data);
};

const duckEliminarHorariosByLocal = createDuck(
  "ELIMINAR_HORARIOS_LOCAL",
  newActions,
  newReducers
);

const eliminarHorariosByLocalThunk = (data) => {
  const url = `${baseUrl}/eliminarHorariosLocal`;
  return createThunk(
    axios,
    "post",
    duckEliminarHorariosByLocal.actions,
    url,
    data
  );
};

const exp = {
  duck,
  cargarLocalThunk,
  duckEditLocal,
  editLocalThunk,
  duckCategoriasForSelect,
  categoriasForSelectThunk,
  duckGetLocales,
  getLocalesThunk,
  duckProfesionalesByLocal,
  profesionalesByLocalThunk,
  duckLocalById,
  localByIdThunk,
  duckServiciosPadre,
  serviciosPadreThunk,
  duckServiciosHijos,
  serviciosHijosThunk,
  duckHorariosByLocal,
  horariosByLocalThunk,
  duckEliminarHorario,
  eliminarHorarioThunk,
  duckEliminarImgLocal,
  eliminarImgLocalThunk,
  duckSugerencias,
  getSugerenciasThunk,
  duckAmbientesByLocal,
  getAmbientesByLocalThunk,
  duckAddAmbiente,
  cargarAmbienteThunk,
  duckUpdateAmbiente,
  updateAmbienteThunk,
  duckAmbienteById,
  getAmbienteByIdThunk,
  duckSegurosByLocal,
  getSegurosByLocalThunk,
  duckAddSeguro,
  cargarSeguroThunk,
  duckUpdateSeguro,
  updateSeguroThunk,
  duckSeguroById,
  getSeguroByIdThunk,
  duckEliminarImgBannerLocal,
  eliminarImgBannerLocalThunk,
  duckSimularPendientes,
  procesarHorariosPendientesThunk,
  duckGetPromos,
  getPromosThunk,
  duckAddPromo,
  addPromoThunk,
  duckDeletePromo,
  deletePromoThunk,
  duckEliminarHorariosByLocal,
  eliminarHorariosByLocalThunk,
};

export default exp;
